// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasCartContext, withCart } from "@insite/client-framework/Components/CartContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import CartTotalDisplay, { CartTotalDisplayStyles } from "@insite/content-library/Components/CartTotalDisplay";
import StyledBox from "@sc/XDL/Components/Common/Box";
import React from "react";

type Props = WidgetProps & HasCartContext;

export interface SavedOrderDetailsTotalStyles {
    cartTotal?: CartTotalDisplayStyles;
}

export const savedOrderDetailsTotalStyles: SavedOrderDetailsTotalStyles = {};

const styles = savedOrderDetailsTotalStyles;

const SavedOrderDetailsTotal = ({ cart }: Props) => {
    if (!cart) {
        return null;
    }

    // XNG-Changes: StyledBox
    return (
        <StyledBox>
            <CartTotalDisplay cart={cart} showTaxAndShipping={false} extendedStyles={styles.cartTotal} />
        </StyledBox>
    );
};

const widgetModule: WidgetModule = {
    component: withCart(SavedOrderDetailsTotal),
    definition: {
        group: "Saved Order Details",
        allowedContexts: ["SavedOrderDetailsPage"],
        displayName: "Saved Order Total",
    },
};

export default widgetModule;
